import { render, staticRenderFns } from "./CommissionDebt.vue?vue&type=template&id=4fa1a83e&scoped=true"
import script from "./CommissionDebt.vue?vue&type=script&lang=js"
export * from "./CommissionDebt.vue?vue&type=script&lang=js"
import style0 from "./CommissionDebt.vue?vue&type=style&index=0&id=4fa1a83e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa1a83e",
  null
  
)

export default component.exports